// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class EventBus {}

export class UnauthorizedEventBus extends EventBus {}

export class DoneLogoutEventBus extends EventBus {}
